import {
  GET_EVENTOS_REALIZADOS_START,
  GET_EVENTOS_REALIZADOS_SUCCESS,
  GET_EVENTOS_REALIZADOS_ERROR
} from '../actions'

const initialState = {
  loading: false,
  payload: [],
  error: null
}

const realizados = (state = initialState, { type, payload, error }) => {

  switch(type) {

    case GET_EVENTOS_REALIZADOS_START:
      return {
        ...state,
        loading: true,
        error: null
      }

    case GET_EVENTOS_REALIZADOS_SUCCESS:
      return {
        ...state,
        loading: false,
        payload
      }

    case GET_EVENTOS_REALIZADOS_ERROR:
      return {
        ...state,
        loading: false,
        error
      }

    default: return state

  }

}

export default realizados